import { text } from '@pdfme/schemas';

const booleanSchema = {
  pdf: text.pdf,
  ui: text.ui,
  propPanel: {
    ...text.propPanel,
    defaultSchema: {
      ...text.propPanel.defaultSchema,
      type: 'boolean',
    },
  },
};

export default booleanSchema;
